export enum PaymentTypeEnum {
  LUMP_SUM = 'PT_LS',
  ANNUAL = 'PT_A',
}
